import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import { addResolutions } from "store/actions/resolutionCenterAction";

function ResolutionCenterAddModal({ addModal, toggleAddModal }) {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: `${user?.first_name} ${user?.last_name}`,
    athleteId: user?.athleteID,
    email: user?.email,
    phoneNumber: user?.phoneNumber,
    type: "",
    description: "",
    createdAt: user?.created_at,
    updatedAt: user?.lastLoggedIn,
    opendBy: user?.role,
    status: "pending",
    userId: user?.id,
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    dispatch(
      addResolutions(formData, () => {
        setIsLoading(false);
        setFormData((prev) => ({
          ...prev,
          type: "",
          description: "",
        }));
        toggleAddModal();
      })
    );
  };

  return (
    <>
      <Modal isOpen={addModal} toggle={toggleAddModal}>
        <ModalHeader toggle={toggleAddModal}>
          Create Resolution Center
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col className="col-6">
                <FormGroup>
                  <Label for="exampleName">Name</Label>
                  <Input
                    id="exampleName"
                    name="name"
                    value={`${user?.first_name} ${user?.last_name}`}
                    disabled
                    type="text"
                  ></Input>
                </FormGroup>
              </Col>
              <Col className="col-6">
                <FormGroup>
                  <Label for="exampleId">Athlete ID</Label>
                  <Input
                    id="exampleId"
                    name="ResolutionId"
                    value={user?.athleteID}
                    disabled
                    type="text"
                  ></Input>
                </FormGroup>
              </Col>
              <Col className="col-6">
                <FormGroup>
                  <Label for="exampleEmail">Email</Label>
                  <Input
                    id="exampleEmail"
                    name="email"
                    value={user?.email}
                    disabled
                    type="text"
                  ></Input>
                </FormGroup>
              </Col>
              <Col className="col-6">
                <FormGroup>
                  <Label for="exampleNumber">Phone No.</Label>
                  <Input
                    id="exampleNumber"
                    name="phoneNumber"
                    value={user?.phoneNumber}
                    disabled
                    type="text"
                  ></Input>
                </FormGroup>
              </Col>
              <Col className="col-12">
                <FormGroup>
                  <Label for="exampleCategory">Category</Label>
                  <Input
                    type="select"
                    name="type"
                    id="exampleCategory"
                    value={formData.type}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="">Select Category</option>
                    <option value="Financial">Financial</option>
                    <option value="Informational">Informational</option>
                    <option value="Sports-Related">Sports-Related</option>
                    <option value="Other">Other</option>
                  </Input>
                </FormGroup>
              </Col>
              <Col className="col-12">
                <FormGroup>
                  <Label for="exampleTextArea">Resolution</Label>
                  <Input
                    id="exampleTextArea"
                    name="description"
                    type="textarea"
                    rows={5}
                    onChange={handleInputChange}
                    value={formData?.resolution}
                    required
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row className="justify-content-center">
              <Button color="primary" type="submit" disabled={isLoading}>
                {isLoading && (
                  <span className="spinner-border spinner-border-sm mr-1"></span>
                )}{" "}
                Add Resoluton
              </Button>
            </Row>
          </Form>
        </ModalBody>
      </Modal>
    </>
  );
}

export default ResolutionCenterAddModal;
